import { ContainerInstance, Service } from 'typedi';
import { z } from 'zod';
import { ContainerTokens } from '../constants';

@Service()
export class EnvironmentService<TEnvironment extends Record<string, unknown>> {
  readonly environment: Readonly<TEnvironment>;

  constructor(container: ContainerInstance) {
    const environmentSchema = container.get<z.ZodObject<z.ZodRawShape>>(
      ContainerTokens.ENVIRONMENT_SCHEMA,
    );
    const processEnv = container.get<Record<string, string>>(
      ContainerTokens.PROCESS_ENV,
    );

    const result = environmentSchema.safeParse(processEnv);
    if (result.success) {
      this.environment = result.data as TEnvironment;
    } else {
      throw new Error(z.prettifyError(result.error));
    }
  }
}
